function Malawi({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1570)">
  <path d="M0 15.9992C0 17.9563 0.352063 19.831 0.995188 21.5643L16 22.26L31.0048 21.5644C31.648 19.831 32 17.9563 32 15.9992C32 14.042 31.648 12.1673 31.0048 10.434L16 9.73828L0.995188 10.4339C0.352063 12.1673 0 14.042 0 15.9992H0Z" fill="#D80027"/>
  <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0Z" fill="black"/>
  <path d="M31.0049 21.5645H0.995239C3.25593 27.6572 9.12061 31.9993 16 31.9993C22.8795 31.9993 28.7442 27.6572 31.0049 21.5645Z" fill="#496E2D"/>
  <path d="M20.7821 7.65276L18.8281 6.73364L19.8687 4.8412L17.7468 5.24714L17.478 3.10352L16 4.68008L14.522 3.10352L14.2531 5.24714L12.1313 4.8412L13.1718 6.73364L11.2178 7.65276H20.7821Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Malawi;
